var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "vs-btn-legacy banner-download__download-app",
      class: [
        _vm.textButton === false
          ? _vm.os === "iOS"
            ? "apps-store"
            : _vm.os === "AndroidOS"
            ? "play-store"
            : "desktop-logo"
          : "",
        _vm.overlay ? "button-overlay" : ""
      ],
      attrs: { tracker: _vm.tracker },
      on: { click: _vm.clickButton }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }